import { render, staticRenderFns } from "./BlocklyEditer.vue?vue&type=template&id=6035d253&scoped=true&"
import script from "./BlocklyEditer.vue?vue&type=script&lang=js&"
export * from "./BlocklyEditer.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyEditer.vue?vue&type=style&index=0&id=6035d253&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035d253",
  null
  
)

export default component.exports